module.exports = __webpack_public_path__ + "static/img/iconPdf.d68bd41.png";